import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData,getCol3} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,
  validateNumberLength,CallMapMethod_frm_CBack,TableDatePicker} from '../function_lib/common_lib';

import {Custom_Alert,Alert_Content} from '../components/custom_alert';
import listData from '../function_lib/customeData';

import Header from './header';
import Footer from './footer';


import defaultPic from '../assets/images/9.png';
import Comp_View_Payment_Breakup from '../components/comp_view_payment_breakup';
import Comp_View_Invoice_Breakup from '../components/comp_view_invoice_breakup';
import Pay_Old_Dues from '../components/pay_old_dues';
import Comp_add_Marks from '../components/comp_add_marks';
import Comp_Edit_Marks from '../components/comp_edit_marks';
//import Wa_Credit_Balance_Comp from '../components/wa_credit_balance';
import 'select2/dist/js/select2.full.min.js';
import 'select2/dist/css/select2.min.css';

import CompStudent_Auto_Complete_New from '../components/comp_auto_complete';

let loginUser="";
let userObject="";
let companyName="";
let clsSubmitFee;


let rf="0";

class Marks_Entry extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }
      this.state={stListBranches:[],stListSessionYear:[],stListClassMaster:[],
        stListStudent:[],
      stStudentInvoice:[],stStuFeeSubmitted:[],stStuOldDues:[],
    stStuPaymentBreakdown:[],stStuInvoiceBreakdown:[],stStudentId:0,
stSubjectmaster:[],stExamMaster:[],stStudentResultsRow:[],
stEditMarksRes:{}
};

      this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
      clsSubmitFee=this;
      }


clkEditMarks(frmName){
  let map=[];
  CallMapMethod_frm_CBack(clsSubmitFee,frmName,map,function(data,msg){

    if(data=="001"){
      alert("Marks added successfully");
      $("#frmAddMarks").find("input[type=text]").val("");
      $("#frmAddMarks").find("input[type=number]").val("");
      //$("#frmAddMarks").find("input[type=text]").val("");
      $("#frmAddMarks").find("select").val("0");

      clsSubmitFee.getStudentFeenDues();
    }
  })
}

saveMarks(frmName){

  if($("#session_year_id").val()===btoa("0")){
    alert("Select session Year..");
    return;
  }
  if($("#class_id").val()===btoa("0")){
    alert("Select Class..");
    return;
  }
  if($("#roll_number").val()===""){
    alert("Enter Roll Number");
    return;
  }


 let map=[];
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"session_year_id",value:$("#session_year_id").val()});
  map.push({name:"class_id",value:$("#class_id").val()});
  map.push({name:"result_date",value:$("#result_date").val()});
  map.push({name:"exam_id",value:$("#exam_id").val()});
  map.push({name:"branch_acc",value:getCol3()});
  map.push({name:"roll_number",value:$("#roll_number").val()});
 
  // alert(getCol3());
  // return;
  
  CallMapMethod_frm_CBack(clsSubmitFee,frmName,map,function(data,msg){
    //alert(data+msg);
    if(data=="001"){
      alert("Marks added successfully");
      $("#frmAddMarks").find("input[type=text]").val("");
      $("#frmAddMarks").find("input[type=number]").val("");
      //$("#frmAddMarks").find("input[type=text]").val("");
      $("#frmAddMarks").find("select").val("0");

      clsSubmitFee.getStudentFeenDues();
    }
  })
  //alert("i am in save marks");
}      
      
getMasters(){
    var map=[];
    map.push({name:"curl_type",value:"getMastersforResult"});
    map.push({name:"res_func",value:"callBackrrr"});
    map.push({name:"local_token",value:userObject[0].app_user_id});
    map.push({name:"branch_acc",value:getCol3()});
    map["res_func"]="callBackrrr";
    map["curl_type"]="getMastersforResult";
    CallMapMethod_CBack(clsSubmitFee,map,function(data,msg){
      //alert(data);
        if(data!=="0" && data!==""){
            let listData=JSON.parse(data);
            var strData="";
            //alert(JSON.stringify(listData.master_balance));
            clsSubmitFee.setState({stListSessionYear:listData.ls_session_year,
              stListClassMaster:listData.ls_class_master,
              
              stExamMaster:listData.ls_exam_master,
            
            
            stListBranches:listData.ls_branches},()=>{
                clsSubmitFee.forceUpdateHandler();
            })
          }
    });
  }

      
  okSuccStuFee(data,smg){
        if(data==="001"){
          alert("Fee submitted successfully");
          window.location.reload();
          //Custom_Alert("Successful","Record Added Successfully",true);
          //clsCategoryMaster.getSessionYear();
          //$("#frmCreate").find("input[type=text]").val("");
        }else{
          alert(smg);
          //Custom_Alert("Not Working",smg,false);
        }
        // alert(data);
      }

      getSubjectExamMarks(){

        let map=[];
  map.push({name:"curl_type",value:"getSubjectExamOuts"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"session_year_id",value:$("#session_year_id").val()});
  map.push({name:"class_id",value:$("#class_id").val()});
  map.push({name:"branch_id",value:$("#branch_id").val()});
  
  map.push({name:"exam_id",value:$("#exam_id").val()});

  map["res_func"]="callBackrrr";
  map["curl_type"]="getSubjectExamOuts";
  CallMapMethod_CBack(clsSubmitFee,map,function(data,msg){
    //alert(data);
    if(data!=="0"){
      let listData=JSON.parse(data);
      clsSubmitFee.setState({stSubjectmaster:listData},()=>{
        clsSubmitFee.forceUpdateHandler();
      });
      
    }
  })


      }      
getStudentByAutoComplete(){
  
  let map=[];
  map.push({name:"curl_type",value:"getStudentDataAutoComp"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"session_year_id",value:$("#session_year_id").val()});
  map.push({name:"class_id",value:$("#class_id").val()});
  map.push({name:"branch_id",value:$("#branch_id").val()});
  map.push({name:"ser_stu_text",value:""});

  map["res_func"]="callBackrrr";
  map["curl_type"]="getStudentDataAutoComp";
  //alert($("#class_id").val());
  CallMapMethod_CBack(clsSubmitFee,map,function(data,msg){
    //alert(data);
    if(data!=="0"){
      let listData=JSON.parse(data);
      clsSubmitFee.setState({stListStudent:listData},()=>{
        $(".select2").select2();
        //alert(JSON.stringify(clsSubmitFee.stListStudent));
        //clsSubmitFee.forceUpdateHandler();
      });
      
    }
  })

}

deleteResultId(item){
  if(window.confirm("Do you want to delete permenantly")){

  
  let map=[];
  map.push({name:"curl_type",value:"deleteResult"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"result_id",value:btoa(item.id)});
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="deleteResult";

  CallMapMethod_CBack(clsSubmitFee,map,function(data,msg){
    if(data==="001"){
      alert("deleted successfully");
      clsSubmitFee.getStudentFeenDues();

    }
  })

  }

}

getMarksByResultId(item){
  
  //alert(JSON.stringify(item));
  //return;

  let map=[];
  map.push({name:"curl_type",value:"getMarksByStudentResultId"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"student_results_id",value:btoa(item.id)});
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="getMarksByStudentResultId";
   
  CallMapMethod_CBack(clsSubmitFee,map,function(data,msg){
    //alert(data);
    if(data!=="0"){
      let lsMarksRes=JSON.parse(data);
      clsSubmitFee.setState({stEditMarksRes:lsMarksRes});
    }

  })

}

getStudentFeenDues(preSetId="0"){
  // alert($("#ser_student_name_id").val());
  // return;
  let map=[];
  map.push({name:"curl_type",value:"getResultRowView"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"session_year_id",value:$("#session_year_id").val()});
  map.push({name:"class_id",value:$("#class_id").val()});
  //map.push({name:"stu_id",value:$("#ser_student_name").val()});
  if(preSetId!=="0"){
    $("#ser_student_name").val(preSetId);
  }
  map.push({name:"stu_id",value:$("#ser_student_name").val()});


  map["res_func"]="callBackrrr";
  map["curl_type"]="getResultRowView";
  clsSubmitFee.setState({stStudentId:$("#ser_student_name").val()}); 
  CallMapMethod_CBack(clsSubmitFee,map,function(data,msg){
    //alert(data);
    if(data!=="0"){
      let listData=JSON.parse(data);
      //alert(JSON.stringify(listData.student_invoice));
      clsSubmitFee.setState({stStudentResultsRow:listData});
    }
  })
}

getInvoiceBreakups(item){
//  alert(JSON.stringify(item));
  let map=[];
  map.push({name:"curl_type",value:"getStudentInvoice"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"session_year_id",value:$("#session_year_id").val()});
  map.push({name:"class_id",value:$("#class_id").val()});
  map.push({name:"stu_id",value:$("#ser_student_name").val()});
  map.push({name:"stu_invoice_id",value:btoa(item.stu_invoice_id)});

  map["res_func"]="callBackrrr";
  
  map["curl_type"]="getStudentInvoice";
  CallMapMethod_CBack(clsSubmitFee,map,function(data,msg){
    //alert(data);
    if(data!=="0"){
      let listData=JSON.parse(data);
      //alert(JSON.stringify(listData.payment_entry));
      clsSubmitFee.setState({stStuInvoiceBreakdown:listData.invoice_breakups});
    }
  })
}
getPaymentEntryBreakups(item){
  //alert(item.id);
  let map=[];
  map.push({name:"curl_type",value:"getStudentFeeBreakdown"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"session_year_id",value:$("#session_year_id").val()});
  map.push({name:"class_id",value:$("#class_id").val()});
  map.push({name:"stu_id",value:$("#ser_student_name").val()});
  map.push({name:"payment_entry_id",value:btoa(item.id)});

  map["res_func"]="callBackrrr";
  map["curl_type"]="getStudentFeeBreakdown";
  CallMapMethod_CBack(clsSubmitFee,map,function(data,msg){
    //alert(data);
    if(data!=="0"){
      let listData=JSON.parse(data);
      //alert(JSON.stringify(listData.payment_entry));
      clsSubmitFee.setState({stStuPaymentBreakdown:listData.payment_breakdown});
    }
  })
}

      
componentDidMount(){
    
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
this.getMasters();

// fee Submission 

//End of fee Submission 
$(".select2").select2();
$("#ser_student_name").on("change",function () { 
  clsSubmitFee.getStudentFeenDues();
  clsSubmitFee.setState({stStudentId:$("#ser_student_name").val()}); 
});


$('#divEditMarks').on('hidden.bs.modal', function () {
  //alert("i m in hide");
  clsSubmitFee.setState({stEditMarksRes:{"nn":"00"}});
  clsSubmitFee.forceUpdateHandler();
 
});


$('#divAddMarks').on('hidden.bs.modal', function () {
  //alert("i m in hide");
  clsSubmitFee.setState({stSubjectmaster:[]});
  clsSubmitFee.forceUpdateHandler();
 
});

}
oldDues_okSucc(data,msg){
  
  if(data==="001"){
    clsSubmitFee.getStudentFeenDues();
    $("#pod_receipt_no").val("");
    $("#pod_value").val("");
    //clsSubmitFee.setState({})
    alert("Old Due Submitted Successfully");
  }
}


      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
  
<div className="row">
   
      <div className="col-md-12 col-sm-12">
         
      <div class="card card-secondary">
              {/* <!-- /.card-header --> */}
           <div class="card-header">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>Result Entry</b></h3>
                
                {/* <a className="btn btn-sm btn-danger float-right" data-toggle="modal" data-target="#divSessionYear" href="javascript:void(0)">Add New</a> */}
              </div>
            {/* form data  */}
            <form class="form-group" id="frmFeeSubmission" name="frmFeeSubmission" enctype="multipart/form-data" method="POST" onsubmit="event.preventDefault()">
                <input type="hidden" name="res_func" id="res_func" value="okSuccStuFee" />
                <input type="hidden" name="curl_type" id="curl_type" value="submitStuFee" />
                <input type="hidden" name="m_type" id="m_type" value="submitStuFee" />
                <input type="hidden" name="wa_msg_ty_ma_id" id="wa_msg_ty_ma_id" value={"1"} />
                <input type="hidden" name="acc_inf_id" id="acc_inf_id" value={userObject[0].app_user_id}/>
            <div class="card-body">           
            <div className="row">
            
<div className='col-lg-2 col-md-2 col-sm-4 float-right'>
<div className="form-group">
<label for="exampleInputEmail1">Branch</label>
         <div className="input-group">
               <select id="branch_id" name="branch_id" className="form-control form-control-sm required">
               {this.state.stListBranches.length>1?<option value={btoa("0")}>-All-</option>:''}
                {this.state.stListBranches.map((item,index)=>{
                  return <option value={btoa(item["id"])}>{item["branch_name"]}</option>
                })}
               </select>
             </div>
         
         </div>
</div>

            <div className="col-lg-2 col-md-2">
                                        <div className="form-group form-group-sm row">
                                            <label for="exampleInputEmail1">Session Year</label>
                                            <div className="input-group input-group-sm">
                                            <select onChange={()=>this.getStudentByAutoComplete()} id="session_year_id" name="session_year_id" className="form-control required">
                                                  <option value={btoa("0")}>-Select Year-</option>
                                                  {this.state.stListSessionYear.map((item,index)=>{
                                                    return <option value={btoa(item.id)}>{item.session_name}</option>
                                                  })}
                                                </select>
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-2 col-md-2">
                                        <div className="form-group form-group-sm row">
                                            <label for="exampleInputEmail1">Class</label>
                                            <div className="input-group input-group-sm">
                                            <select onChange={()=>this.getStudentByAutoComplete()} id="class_id" name="class_id" className="form-control required">
                                                  <option value={btoa("0")}>-Select Class-</option>
                                                  {this.state.stListClassMaster.map((item,index)=>{
                                                    return <option value={btoa(item.id)}>{item.class_name}</option>
                                                  })}
                                                </select>
                                            </div>
                                        </div>
                                  </div>
                                  

                                  <div className="col-lg-2 col-md-2">
                                        <div className="form-group form-group-sm row">
                                            <label for="exampleInputEmail1">Result Date</label>
                                            <div className="input-group input-group-sm">
                                            <TableDatePicker refName="result_date" />
                                            </div>
                                        </div>
                                  </div>

                                  

            </div>
{/* end of first row */}
{/* student row */}
<div class="row">

<div className="col-lg-4 col-md-4">
                                        <div className="form-group form-group-sm row">
                                            <label for="exampleInputEmail1">Student Name</label>
                                            <div className="input-group input-group-sm">
                                            
                                              <CompStudent_Auto_Complete_New
                                                comp_id={"ser_student_name_id"} compOnChange={this.getStudentFeenDues} comp_name={"ser_student_name_id"} 
                                                studentList={this.state.stListStudent}
                                                target_obj={"ser_student_name"} placeHolder={"Student Name"} propClass={"form-control form-control-sm"}
                                              />
                                            </div>
                                        </div>
                                  </div>

                                  <div className="col-lg-2 col-md-2">
                                        <div className="form-group form-group-sm row">
                                            <label for="exampleInputEmail1">Exam.</label>
                                            <div className="input-group input-group-sm">
                                                <select onChange={()=>this.getSubjectExamMarks()} class="form-control required" id="exam_id" name="exam_id">
                                                  <option value="0">-Select</option>
                                                  {this.state.stExamMaster.map((item,index)=>{
                                                    return <option value={btoa(item["id"])}>{item["exam_nm"]}</option>
                                                  })}
                                                </select>
                                            
                                            </div>
                                        </div>
                                  </div>

                                  <div className="col-lg-2 col-md-2">
                                        <div className="form-group form-group-sm row">
                                            <label for="exampleInputEmail1">Roll Number.</label>
                                            <div className="input-group input-group-sm">
                                            <input className="form-control required" type="number" id="roll_number" name="roll_number"/>
                                            </div>
                                        </div>
                                  </div>

                                  <div class="col-lg-2 col-md-2">
                        <div class="form-group form-group-sm">
                        <label for="exampleInputEmail1"></label>
                            <div class="input-group input-group-sm">
                                <button type="button" data-bs-toggle="modal" data-bs-target="#divAddMarks" data-toggle="modal" data-target="#divAddMarks" class="btn btn-sm btn-danger">Enter Exam Marks</button>
                            </div>
                        </div>
                    </div>


</div>
{/* enter student row */}
{/* table fee Breakdown */}
<div class="row">
<table class="table table-bordered table-sm">
                                        <thead>
                                            <tr className="white" style={{"background-color":"#5B84B1FF"}}>
                                            <th>Session Year</th>
                                                <th>Exam Name</th>
                                                <th>Student Name</th>
                                                <th>Class</th>
                                                <th>Roll No.</th>
                                                <th>Total Marks</th>
                                                <th>Marks Obt.</th>
                                                <th>Marks(%).</th>
                                                <th>Division</th>
                                                <th>Grade</th>
                                                <th>Result</th>
                                                {/* <th>Grade</th> */}
                                                
                                                <th style={{"width":"40px"}}></th>
                                            </tr>
                                            {this.state.stStudentResultsRow.map((item,index)=>{
                                              return <tr>
                                                <td>{item["session_name"]}</td>
                                                <td>{item["exam_nm"]}</td>
                                                <td>{item["student_name"]}</td>
                                                <td>{item["class_name"]}</td>
                                                <td>{item["roll_number"]}</td>
                                                <td>{item["total_marks"]}</td>
                                                <td>{item["obtain_marks"]}</td>
                                                <td>{item["marks_per"]}</td>
                                                <td>{item["obt_division"]}</td>
                                                <td>{item["obt_grade"]}</td>
                                                <td>{item["result_pass"]}</td>
                                                <td>
                                                <div class="btn-group">
                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" area-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu">
                    <a class="dropdown-item" onClick={()=>this.getMarksByResultId(item)} data-toggle="modal" data-target="#divEditMarks" href="javascript:void(0)">Edit Marks</a>
                    <a class="dropdown-item" onClick={()=>this.deleteResultId(item)} data-bs-toggle="modal" data-bs-target="#divViewEntryLogs"  href="javascript:void(0)">Delete Record</a>
                   
                      
                    </div>
                  </div>
                                                </td>
                                              </tr>
                                            })}
                                            
                                        </thead>
                                       
                                    </table>
                                   
                                </div>
                              

            </div>
            <div class="row">
               
                   
                   
                   

                </div>
            </form>
            {/* end of form data */}
                
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Alert_Content/>
<Footer/>
<Comp_Edit_Marks clkEditMarks={this.clkEditMarks} editMarks={this.state.stEditMarksRes} />
<Comp_add_Marks saveMarks={this.saveMarks} lsSubjects={this.state.stSubjectmaster} app_user_id={userObject[0].app_user_id} studentId={this.state.stStudentId} />
<Comp_View_Payment_Breakup paymentBreakdown={this.state.stStuPaymentBreakdown}/>
<Comp_View_Invoice_Breakup invoiceBreakdown={this.state.stStuInvoiceBreakdown} />
<Pay_Old_Dues app_user_id={userObject[0].app_user_id} studentId={this.state.stStudentId} stuOldDues={this.state.stStuOldDues}/>
    {/* <Wa_Credit_Balance_Comp creditUser={this.state.crediUser} creditBalance={this.state.creditBalance} masterBalance={this.state.masterBalance} app_user_id={userObject[0].app_user_id} /> */}
          </div>)
      }
}
export default Marks_Entry;